(() => {
  const THRESHOLD_CENTS = 6900;
  const GIFT_VARIANT_ID = 52498045108551;

  function formatMoneyFromCents(cents) {
    const value = (Math.max(0, cents) / 100).toFixed(2).replace(".", ",");
    return `€${value}`;
  }

  async function fetchCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("cart.js failed");
    return res.json();
  }

  function eligibleSubtotalCents(cart) {
    let sum = 0;
    for (const item of cart.items || []) {
      const vid = Number(item.variant_id || item.id);
      if (vid === Number(GIFT_VARIANT_ID)) continue; // escludi regalo
      sum += Number(item.final_line_price || 0);
    }
    return sum;
  }

  function updateUI(cart) {
    const fill = document.getElementById("GiftNotifFill");
    const text = document.getElementById("GiftNotifText");
    if (!fill || !text) return;

    const eligible = eligibleSubtotalCents(cart);
    const capped = Math.min(eligible, THRESHOLD_CENTS);
    const remaining = THRESHOLD_CENTS - eligible;

    const progress = Math.max(0, Math.min(100, Math.round((capped * 100) / THRESHOLD_CENTS)));

    // FORCE: width + colore giallo sempre visibile
    fill.style.setProperty("width", `${progress}%`, "important");
    fill.style.setProperty("height", "100%", "important");
    fill.style.setProperty(
      "background",
      "linear-gradient(90deg, #f5c400, #ffdd55)",
      "important"
    );
    fill.style.setProperty("display", "block", "important");
    fill.style.setProperty("opacity", "1", "important");
    fill.style.setProperty("visibility", "visible", "important");

    if (remaining > 0) {
      text.innerHTML =
        `🎁 Mancano <strong>${formatMoneyFromCents(remaining)}</strong> ` +
        `per avere gli <strong>orecchini drop placcato oro gratis</strong>.`;
    } else {
      text.innerHTML = `🎉 <strong>Hai sbloccato gli orecchini drop placcato oro gratis!</strong>`;
    }
  }

  let timer = null;
  let busy = false;
  let lastRunAt = 0;

  function scheduleRefresh() {
    clearTimeout(timer);

    timer = setTimeout(async () => {
      // throttle per non martellare il cart.js
      const now = Date.now();
      if (now - lastRunAt < 300) return;
      lastRunAt = now;

      if (busy) return;
      busy = true;

      try {
        const cart = await fetchCart();
        updateUI(cart);
      } catch (e) {
        console.warn("[GiftNotif]", e);
      } finally {
        busy = false;
      }
    }, 150); // leggermente più alto per far montare il popup
  }

  document.addEventListener("DOMContentLoaded", () => {
    scheduleRefresh();

    const target = document.getElementById("cart-notification");
    if (!target) return;

    const obs = new MutationObserver(() => scheduleRefresh());
    obs.observe(target, { attributes: true, childList: true, subtree: true });
  });
})();
